import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch, useHistory } from "react-router-dom";
import { createWidget } from "actions/editor";

import {
  fetchPaletteFolders,
  fetchComponentsForPalette,
} from "actions/palette";

import cx from "classnames";
import _ from "lodash";
import { Nav, Tab, Button, Image } from "react-bootstrap";
import { createMixpanelEvent } from "actions/mixpanel";
import { MIXPANEL_WIDGET_USED } from "constants/mixpanelEvents";
import { getStoryboardMixpanelEventPayload } from 'services/mixpanelUtil';
import StoryboardContext from 'components/Storyboard/context';

import { PaletteContext } from ".";
import InfiniteScroll from "components/InfiniteScroll";
import { getBaseUrl } from "services/util";
import { getPositionForNewWidget } from "components/Editor/helper/layoutManager";
import Tooltip from "components/Tooltip";
import Truncate from "react-truncate";
import { fetchCreatedForms } from "actions/forms/forms";

import {
  FORM_STEP,
  FORM_SUBMIT,
  OTP_FORM_SUBMIT,
  OTP_INPUT,
  OTP_RESEND,
  EXTERNAL_FORM,
} from "constants/widgetTypes";
import { INTEGRATION_TYPES } from "constants/integrationList";
import { TEXT, FORM_FIELD } from "constants/widgetTypes";
import { FORM } from "constants/widgetTypes";

import styles from "./palette.module.scss";
import {
  MultiwidgetPaletteComponentsView,
  FolderPaletteComponentsView,
} from "./multiWidgetFolderPalette";
import { ShortLoader } from "components/ApplicationLoader";

const production = process.env.NODE_ENV === "production";
const imageId = production
  ? "62e3ab81dbfd3e6ec4a2a133"
  : "62de5538833d8a337666b497";

export const FormsPalette = ({ editorSession, defaultParent }) => {
  const paletteContext = React.useContext(PaletteContext);

  const { palettes = [] } = paletteContext;

  const paletteData = palettes.find((item) => item.type === "FORMS");
  const defaultId = _.get(paletteData, "defaultId", null);
  const brandkitId = _.get(paletteData, "brandkitId", null);

  return (
    <Tab.Pane
      eventKey="FORMS"
      className={cx(styles.tabPane, styles.commonPalette)}
    >
      <FormsBrandkitPalette
        editorSession={editorSession}
        defaultParent={defaultParent}
        paletteId={brandkitId}
        type={'default'}
        paletteData={paletteData}
        defaultPaletteId={defaultId}
        typeName={'FORMS'}
      />
    </Tab.Pane>
  );
};

export const FormsBrandkitPalette = ({ editorSession, defaultParent, defaultPaletteId, paletteId, type, paletteData, typeName,}) => {
  const dispatch = useDispatch();

  //Form
  const storyboardContext = React.useContext(StoryboardContext);

  const [formView, setFormView] = useState("default");

  const changeFormViewClicked = (value, folder) => {
    setFormView(value);

    if(folder){
      handleFolderSelect(folder)
    }
   
  };

  const history = useHistory();
  const loading = useSelector((state) => _.get(state, `forms.loading`, false));
  const brandkitLoading = useSelector(state => { return _.get(state, `palette.brandkit[${paletteId}].loading`) || false });
  const pagination = useSelector((state) =>
    _.get(state, "forms.pagination", {})
  );
  const hasMoreItems =
    _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;
  const integrationTypes = _.filter(INTEGRATION_TYPES, { forms: true });
  const activatedIntegrations = useSelector((state) =>
    _.get(state, "integrations.activated.items", [])
  );

  const sortIntegrations = () => {
    const integrationOrder = _.map(integrationTypes, "type");
    const filteredList = _.filter(activatedIntegrations, (item) =>
      _.includes(integrationOrder, item.type)
    );

    return _.sortBy(filteredList, (item) =>
      _.indexOf(integrationOrder, item.type)
    );
  };

  let activeIntegrations = sortIntegrations();

  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const createdForms = useSelector((state) =>
    _.get(state, `forms.items`, null)
  );

  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector((state) => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return widgets.find((widget) => {
      return widget.uid === defaultParent;
    });
  });

  const desktopParentLayout = _.get(parentWidget, `properties.desktop.layout`);
  const mobileParentLayout = _.get(parentWidget, `properties.mobile.layout`);

  const handleManageForms = () => {
    const url = `${baseUrl}/integration-settings/forms`;
    history.push(url);
  };

  const production = process.env.NODE_ENV === "production";
  const imageId = production
    ? "62e3ab81dbfd3e6ec4a2a133"
    : "62de5538833d8a337666b497";

  const handleCreateExternalForm = (form, data) => {
    var mixpanelPayload = getStoryboardMixpanelEventPayload(storyboardContext.id, storyboardContext.name, storyboardContext.type);
    mixpanelPayload = {
      ...mixpanelPayload,
         widget_type: "Form",
         brandkit_widget: false,
         palette_id: form?.id
    }
    dispatch(createMixpanelEvent(MIXPANEL_WIDGET_USED, mixpanelPayload));
    const desktopPosition = getPositionForNewWidget(
      editorSession,
      desktopParentLayout,
      { width: 600, height: 415 }
    );
    const mobilePosition = getPositionForNewWidget(
      editorSession,
      mobileParentLayout,
      { width: 335, height: 463 }
    );

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: EXTERNAL_FORM,
            name: "Form",
            properties: {
              desktop: {
                visible: true,
                layout: {
                  transform: {
                    translate: `${desktopPosition.x}px, ${desktopPosition.y}px`,
                    rotate: "0deg",
                  },
                  width: "600px",
                  height: `415px`,
                },
                border: null,
                background: {
                  r: 245,
                  g: 245,
                  b: 245,
                  a: 1,
                },
              },
              mobile: {
                visible: true,
                layout: {
                  transform: {
                    translate: `${mobilePosition.x}px, ${mobilePosition.y}px`,
                    rotate: "0deg",
                  },
                  width: "335px",
                  height: `463px`,
                },
              },
            },
            order: 1,
            widgets: [
              {
                type: FORM_STEP,
                name: "Success",
                properties: {
                  desktop: {
                    visible: true,
                    layout: {
                      transform: {
                        translate: `0px, 0px`,
                        rotate: "0deg",
                      },
                    },
                  },
                  mobile: {
                    visible: true,
                    layout: {
                      transform: {
                        translate: `0px, 0px`,
                        rotate: "0deg",
                      },
                    },
                  },
                },
                widgets: [
                  {
                    type: TEXT,
                    name: "Form Title",
                    properties: {
                      desktop: {
                        visible: true,
                        layout: {
                          transform: {
                            translate: "30px,268px",
                            rotate: "0deg",
                            scale: "1,1",
                          },
                          width: "353.461px",
                          height: "auto",
                        },
                        fontSize: "16",
                        lineSpacing: "1.2",
                        letterSpacing: "0",
                        color: null,
                        alignment: "left",
                        animation: null,
                      },
                      mobile: {
                        visible: true,
                        layout: {
                          transform: {
                            translate: "20px,336.00048828125px",
                            rotate: "0deg",
                            scale: "1,1",
                          },
                          width: "261px",
                          height: "auto",
                        },
                        fontSize: "32",
                        lineSpacing: "1.2",
                        letterSpacing: "0",
                        color: null,
                        alignment: "left",
                        animation: null,
                      },
                    },
                    content:
                      "<h3><strong>Thanks </strong></h3>\n<h3><strong>for submitting!</strong></h3>",
                  },
                  {
                    type: TEXT,
                    name: "Form Title",
                    properties: {
                      desktop: {
                        visible: true,
                        layout: {
                          transform: {
                            translate: "30px, 360px",
                            rotate: "0deg",
                            scale: "1,1",
                          },
                          width: "auto",
                          height: "auto",
                        },
                        fontSize: "16",
                        lineSpacing: "1.2",
                        letterSpacing: "0",
                        color: null,
                        alignment: "left",
                        animation: null,
                      },
                      mobile: {
                        visible: true,
                        layout: {
                          transform: {
                            translate: "20px, 415px",
                            rotate: "0deg",
                            scale: "1,1",
                          },
                          width: "238.4921875px",
                          height: "auto",
                        },
                        fontSize: "16",
                        lineSpacing: "1.2",
                        letterSpacing: "0",
                        color: null,
                        alignment: "left",
                        animation: null,
                      },
                    },
                    content: "<p>We’ll get back to you shortly :)</p>",
                  },
                  {
                    type: "cleverstory.v2.widgets.image",
                    name: "Image",
                    capabilities: null,
                    order: 1,
                    fonts: null,
                    actions: null,
                    properties: {
                      desktop: {
                        visible: true,
                        shadow: {
                          color: {
                            r: 255,
                            g: 255,
                            b: 255,
                            a: 1,
                          },
                          axes: {
                            x: 0,
                            y: 0,
                            b: 0,
                          },
                          show: false,
                        },
                        layout: {
                          transform: {
                            translate:
                              "198.0000000000001px,48.99999999999969px",
                            rotate: "0deg",
                            scale: "1,1",
                          },
                          width: "317px",
                          height: "274.961px",
                        },
                        crop: null,
                        alt: null,
                      },
                      mobile: {
                        visible: true,
                        layout: {
                          transform: {
                            translate: "20px,20px",
                            rotate: "0deg",
                          },
                          width: "295px",
                          height: "256.0584635416667px",
                        },
                        crop: null,
                        alt: null,
                      },
                    },
                    content: {
                      id: imageId,
                      contentType: "image/png",
                      type: "image",
                      width: 500.0,
                      height: 434.0,
                      url: `public/cleverstory/v2/media/images/${imageId}/thankyou.png`,
                    },
                  },
                ],
                order: 2,
              },
            ],
            content: form,
          },
        ],
        defaultParent
      )
    );

    paletteContext.close();
  };

  const loadMore = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }

    dispatch(fetchCreatedForms(nextPage, 20, "hubspot"));
  };

  useEffect(() => {
    dispatch(fetchCreatedForms(0, 20, "hubspot"));
  }, []);

  const RenderFormName = ({ id, formName }) => {
    const [tooltip, setTooltip] = useState(false);

    const handleTooltip = (isTruncated) => {
      setTooltip(isTruncated);
    };

    return (
      <Tooltip key={id} placement="top" content={formName} disabled={!tooltip}>
        <Truncate
          lines={1}
          width={140}
          ellipsis="..."
          onTruncate={handleTooltip}
        >
          {formName}
        </Truncate>
      </Tooltip>
    );
  };

  const ExternalForms = ({ formType }) => {
    const forms = createdForms.filter((item) => {
      return item.type == formType;
    });

    return (
      <>
        <div className={styles.manageForm}>
          <Button
            variant="primary"
            onClick={handleManageForms}
            className={styles.actionButton}
          >
            Manage Forms
          </Button>
        </div>
        <InfiniteScroll
          loading={loading}
          hasMore={hasMoreItems}
          loadMore={loadMore}
        >
          <div className={styles.formsCardContainer}>
            {loading && forms.length === 0 && (
              <div className={styles.loadingMessage}>Loading Forms...</div>
            )}

            {!loading && forms && forms.length == 0 && (
              <div className={styles.emptyMessage}>
                No Forms Found in your Supplies
              </div>
            )}
            {forms?.map((form) => {
                return (
                  <div>
                    <div
                      className={styles.formsCard}
                      key={form.id}
                      onClick={() => handleCreateExternalForm(form, {})}
                    >
                      <img src="/images/forms/formPreview.svg" alt="" />
                    </div>
                    <div className={styles.formName}>
                      <RenderFormName id={form.id} formName={form.name} />
                    </div>
                  </div>
                );
              })}
          </div>
        </InfiniteScroll>
      </>
    );
  };

  //
  const iconPaletteRef = React.useRef(null);

  const folders = useSelector((state) =>
    _.get(state, `palette.brandkit[${paletteId}].folders.items`, [])
  );
  const defaultFolders = useSelector((state) =>
    _.get(state, `palette.default[${defaultPaletteId}].folders.items`, [])
  );

  const fetched = useSelector((state) =>
    _.get(state, `palette.default[${paletteId}].folders.fetched`, false)
  );
  const fetchedDefault = useSelector((state) =>
    _.get(state, `palette.default[${defaultPaletteId}].folders.fetched`, false)
  );

  const components = useSelector((state) => {
    return _.get(state, `palette.brandkit[${paletteId}].items`) || [];
  });

  const workspace = useSelector((state) =>
    _.get(state, "workspaces.workspace.item")
  );

  const brandkitEnabled = _.get(workspace, "brandkitEnabled", false);
  const showDefault = _.get(paletteData, "showDefault", false) || !brandkitEnabled;

  const showOtherBrandkitFolder = components.length > 0;

  const showEmptyMessage = components.length == 0 && !showDefault && folders.length == 0;

  useEffect(() => {
    if (showEmptyMessage === true) {
     setFormView('external')
    }else{
      setFormView('default')
    }
  },[showEmptyMessage]);  

  useEffect(() => {
    if (paletteId && !fetched) {
      dispatch(fetchPaletteFolders(paletteId, "brandkit"));
      handleComponentsForPalette(0);
    }
  }, [paletteId]);

  useEffect(() => {
    if (defaultPaletteId && !fetchedDefault) {
      dispatch(fetchPaletteFolders(defaultPaletteId, "default"));
      handleComponentsForPalette(0);
    }
  }, [defaultPaletteId]);

  const handleComponentsForPalette = (page) => {
    var request = {
      sort: "order",
      order: "ASC",
    };
    dispatch(
      fetchComponentsForPalette(paletteId, "brandkit", request, page, 50)
    );
  };

  const handleFolderSelect = (folder) => {
    const folderElement = document.getElementById(folder);
    if (folderElement) {
      folderElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  if(loading || brandkitLoading) return (
    <div className={styles.paletteLoaderContainer}>
      <ShortLoader className={styles.paletteLoaderContainer}/>
    </div>
  )

  return (
    <>
        <div className={styles.iconManagement}>
          <div className={styles.iconFolders}>
            <Nav variant="pills" className={styles.iconManagementTab}>
              {brandkitEnabled &&
                (folders.length > 0 || showOtherBrandkitFolder) && (
                  <>
                    <div className={styles.headerTitle}>{`BRAND ${typeName}`}</div>
                    {folders.map((folder) => {
                      return (
                        <Nav.Item
                          key={folder.id}
                          onClick={() => {
                            changeFormViewClicked("default", folder.id);
                          }}
                        >
                          <Nav.Link eventKey={folder.id}>
                            {folder.name}
                          </Nav.Link>
                        </Nav.Item>
                      );
                    })}

                    {showOtherBrandkitFolder && (
                      <Nav.Item
                        key={`${paletteId}_otherFolder`}
                        onClick={() => {
                          changeFormViewClicked("default", `${paletteId}_otherFolder`);
                        }}
                      >
                        <Nav.Link eventKey={`${paletteId}_otherFolder`}>
                          Other
                        </Nav.Link>
                      </Nav.Item>
                    )}
                    <hr />
                  </>
                )}

              {showDefault && (
                <>
                  <div className={styles.headerTitle}>CLEVERSTORY</div>
                  {defaultFolders.map((folder) => {
                    return (
                      <Nav.Item
                        key={folder.id}
                        onClick={() => {
                         changeFormViewClicked("default", folder.id);
                        }}
                      >
                        <Nav.Link eventKey={folder.id}>{folder.name}</Nav.Link>
                      </Nav.Item>
                    );
                  })}

                  {!_.includes(["ASSET GRIDS"], typeName) && (
                    <Nav.Item
                      key={`${paletteId}_defaultFolder`}
                      onClick={() => {
                        changeFormViewClicked("default", `${paletteId}_defaultFolder`);
                      }}
                    >
                      <Nav.Link eventKey={`${paletteId}_defaultFolder`}>
                        Default
                      </Nav.Link>
                    </Nav.Item>
                  )}
                  <hr />
                </>
              )}

              <>
                <div className={styles.headerTitle}>EXTERNAL FORMS</div>
                <div className={styles.formManagementTab}>
                  {activeIntegrations.length > 0 &&
                    activeIntegrations.map((integration) => {
                      return (
                        <Nav.Item>
                          <Nav.Link
                            eventKey={integration.type}
                            onClick={() => {
                              changeFormViewClicked(integration.type);
                            }}
                          >
                            <div className={styles.logoContainer}>
                              <Image
                                src={`/images/integrations/${integration.type}.png`}
                              />
                              <div id="#contact_form"></div>
                            </div>
                            {integration.type}
                          </Nav.Link>
                        </Nav.Item>
                      );
                    })}

                  {
                    <Nav.Item>
                      <Nav.Link eventKey={"external"}  onClick={() => {
                              changeFormViewClicked('external');
                            }}>
                        <div className={styles.logoContainer}>
                          <Image src={`/images/forms/external_form.svg`} />
                        </div>
                        external
                      </Nav.Link>
                    </Nav.Item>
                  }
                </div>
              </>
            </Nav>
          </div>

          <div className={styles.iconContent} ref={iconPaletteRef}>
            {formView === "default" && (
              <>
                {brandkitEnabled &&
                  (folders.length > 0 || showOtherBrandkitFolder) && (
                    <>
                      <div
                        className={cx(styles.paletteTitle, styles.shapeTitle)}
                      >
                        <h3 className={styles.label}>{`BRAND ${typeName}`}</h3>
                        <hr className={styles.labelHighliter} />
                      </div>

                      <>
                        {folders.map((folder) => {
                          return (
                            <FolderPaletteComponentsView
                              key={folder.id}
                              editorSession={editorSession}
                              defaultParent={defaultParent}
                              paletteId={paletteId}
                              folder={folder}
                              type={"brandkit"}
                            />
                          );
                        })}

                        {showOtherBrandkitFolder && (
                          <MultiwidgetPaletteComponentsView
                            editorSession={editorSession}
                            defaultParent={defaultParent}
                            paletteId={paletteId}
                            type={"brandkit"}
                            typeName={typeName}
                            folderName={"Other"}
                            folderId={`${paletteId}_otherFolder`}
                          />
                        )}
                      </>
                    </>
                  )}
                  {showDefault && (
                          <>
                            <div
                              className={cx(
                                styles.paletteTitle,
                                styles.shapeTitle
                              )}
                            >
                              <h3 className={styles.label}>CLEVERSTORY</h3>
                              <hr className={styles.labelHighliter} />
                            </div>

                            {defaultFolders.map((folder) => {
                              return (
                                <FolderPaletteComponentsView
                                  key={folder.id}
                                  editorSession={editorSession}
                                  defaultParent={defaultParent}
                                  paletteId={defaultPaletteId}
                                  folder={folder}
                                  type={"default"}
                                />
                              );
                            })}

                            {!_.includes(["ASSET GRIDS"], typeName) && (
                              <MultiwidgetPaletteComponentsView
                                editorSession={editorSession}
                                defaultParent={defaultParent}
                                paletteId={defaultPaletteId}
                                type={"default"}
                                typeName={typeName}
                                folderName={"Default"}
                                folderId={`${paletteId}_defaultFolder`}
                              />
                            )}
                          </>
                        )}
              </>
            )}

            {formView === "hubspot" && <ExternalForms formType={"hubspot"} />}

            {formView === "marketo" && <ExternalForms formType={"marketo"} />}

            {formView === "pardot" && <ExternalForms formType={"pardot"} />}

            {formView === "external" && <ExternalForms formType={"external"} />}
          </div>
        </div>

    </>
  );
};

export const defaultOtpWidgets = [
  {
    type: TEXT,
    name: "Form Title",
    properties: {
      desktop: {
        visible: true,
        layout: {
          transform: {
            translate: "141.33px,40px",
            rotate: "0deg",
            scale: "1,1",
          },
          width: "auto",
          height: "auto",
        },
        fontSize: "16",
        lineSpacing: "1.2",
        letterSpacing: "0",
        color: null,
        alignment: "left",
        animation: null,
      },
      mobile: {
        visible: true,
        layout: {
          transform: {
            translate: "30.275px,50px",
            rotate: "0deg",
          },
          width: "274.45px",
          height: "auto",
        },
        fontSize: "32",
        lineSpacing: "1.2",
        letterSpacing: "0",
        color: null,
        alignment: "left",
        animation: null,
      },
    },
    content: "<h3>Please enter OTP</h3>",
  },
  {
    type: TEXT,
    name: "Form Title",
    properties: {
      desktop: {
        visible: true,
        layout: {
          transform: {
            translate: "84.06px, 125px",
            rotate: "0deg",
            scale: "1,1",
          },
          width: "auto",
          height: "auto",
        },
        fontSize: "12",
        fontFamily: null,
        lineSpacing: null,
        letterSpacing: null,
        color: null,
        animation: null,
      },
      mobile: {
        visible: true,
        layout: {
          transform: {
            translate: "27.5px, 135px",
            rotate: "0deg",
            scale: "1,1",
          },
          width: "280px",
          height: "auto",
        },
        fontSize: "12",
        fontFamily: null,
        lineSpacing: null,
        letterSpacing: null,
        color: null,
      },
    },
    content:
      '<p style="font-size: 12px;" >A One-Time Passcode has been sent to your email as a verification code.</p>',
  },
  {
    type: OTP_INPUT,
    name: "OTP",
    properties: {
      desktop: {
        visible: true,
        layout: {
          transform: {
            translate: "184px,180px",
            rotate: "0deg",
            scale: "1,1",
          },
          width: "auto",
          height: "auto",
        },
        field: "otp",
        label: null,
        placeholder: null,
        workEmail: false,
        mandatory: true,
        styles: {
          layout: {
            alignment: "left",
            labelPadding: "0",
            inputPadding: "12",
            fieldSpacing: "8",
            width: "50",
            height: "50",
            regular: null,
          },
          regular: {
            border: {
              sides: null,
              color: {
                type: "solid",
                r: 0,
                g: 0,
                b: 0,
                a: 1,
              },
              width: "2",
              radius: null,
              style: "bottom",
            },
            label: {
              background: null,
              color: {
                type: "solid",
                r: 0,
                g: 0,
                b: 0,
                a: 1,
              },
              placeholderColor: null,
              font: {
                style: null,
                fontSize: "12",
                fontFamily: "Montserrat,sans-serif",
                lineSpacing: null,
                letterSpacing: null,
                color: null,
              },
            },
            input: {
              background: {
                type: "solid",
                r: 255,
                g: 255,
                b: 255,
                a: 1,
              },
              color: {
                type: "solid",
                r: 0,
                g: 0,
                b: 0,
                a: 1,
              },
              placeholderColor: {
                type: "solid",
                r: 213,
                g: 213,
                b: 213,
                a: 1,
              },
              font: {
                style: null,
                fontSize: "14",
                fontFamily: "Montserrat,sans-serif",
                lineSpacing: null,
                letterSpacing: null,
                color: null,
              },
            },
          },
        },
      },
      mobile: {
        visible: true,
        layout: {
          transform: {
            translate: "55.5px,215px",
            rotate: "0deg",
            scale: "1,1",
          },
          width: "auto",
          height: "auto",
        },
        field: "otp",
        label: null,
        placeholder: null,
        workEmail: false,
        mandatory: true,
        styles: {
          layout: {
            alignment: "left",
            labelPadding: "0",
            inputPadding: "12",
            fieldSpacing: "8",
            width: "50",
            height: "50",
            regular: null,
          },
        },
      },
    },
  },
  {
    type: TEXT,
    name: "Form Title",
    properties: {
      desktop: {
        visible: true,
        layout: {
          transform: {
            translate: "192.595px,250px",
            rotate: "0deg",
            scale: "1,1",
          },
          width: "auto",
          height: "auto",
        },
        fontSize: "12",
        fontFamily: null,
        lineSpacing: null,
        letterSpacing: null,
        color: null,
        animation: null,
      },
      mobile: {
        visible: true,
        layout: {
          transform: {
            translate: "60.055px, 285px",
            rotate: "0deg",
            scale: "1,1",
          },
          width: "214.89px",
          height: "auto",
        },
        fontSize: "12",
        fontFamily: null,
        lineSpacing: null,
        letterSpacing: null,
        color: null,
      },
    },
    content:
      '<p style="font-size: 12px;" >This code will be valid for 2 minutes.</p>',
  },
  {
    type: OTP_FORM_SUBMIT,
    name: "OTP Submit Button",
    properties: {
      desktop: {
        visible: true,
        layout: {
          transform: {
            translate: "235px,290px",
            rotate: "0deg",
            scale: "1,1",
          },
          width: "130px",
          height: "40px",
        },
        regular: {
          font: {
            style: {
              bold: false,
              italic: false,
              underline: false,
            },
            fontSize: "14",
            fontFamily: null,
            lineSpacing: null,
            letterSpacing: null,
            color: {
              type: "solid",
              r: 0,
              g: 0,
              b: 0,
              a: 1,
            },
          },
          background: {
            type: "solid",
            r: 255,
            g: 198,
            b: 0,
            a: 1,
          },
          border: {
            sides: null,
            color: null,
            width: "0",
            radius: {
              lock: true,
              topLeft: "20",
              topRight: "20",
              bottomLeft: "20",
              bottomRight: "20",
            },
          },
          shadow: null,
        },
        hover: {
          font: {
            style: null,
            fontSize: null,
            fontFamily: null,
            lineSpacing: null,
            letterSpacing: null,
            color: {
              type: "solid",
              r: 0,
              g: 0,
              b: 0,
              a: 1,
            },
          },
          background: {
            type: "solid",
            r: 255,
            g: 198,
            b: 0,
            a: 1,
          },
          border: null,
          shadow: null,
        },
        alignment: null,
        animation: null,
      },
      mobile: {
        visible: true,
        layout: {
          transform: {
            translate: "102.5px,325px",
            rotate: "0deg",
            scale: "1,1",
          },
          width: "130px",
          height: "40px",
        },
        regular: {
          font: {
            style: null,
            fontSize: "14",
            fontFamily: null,
            lineSpacing: null,
            letterSpacing: null,
            color: null,
          },
          background: null,
          border: null,
          shadow: null,
        },
        hover: {
          font: {
            style: null,
            fontSize: null,
            fontFamily: null,
            lineSpacing: null,
            letterSpacing: null,
            color: null,
          },
          background: null,
          border: null,
          shadow: null,
        },
        alignment: null,
        animation: null,
      },
    },
    content: "Submit",
  },
  {
    type: OTP_RESEND,
    name: "OTP Resend Button",
    properties: {
      desktop: {
        visible: true,
        layout: {
          transform: {
            translate: "206.74px,360px",
            rotate: "0deg",
            scale: "1,1",
          },
          width: "181.21px",
          height: "20px",
        },
        regular: {
          font: {
            style: {
              bold: true,
              italic: false,
              underline: false,
            },
            fontSize: "13",
            fontWeight: "550",
            fontFamily: null,
            lineSpacing: null,
            letterSpacing: null,
            color: {
              type: "solid",
              r: 0,
              g: 0,
              b: 0,
              a: 1,
            },
          },
          background: {
            type: "solid",
            r: 0,
            g: 0,
            b: 0,
            a: 0,
          },
          border: {
            sides: null,
            color: null,
            width: "0",
            radius: {
              lock: true,
              topLeft: "0",
              topRight: "0",
              bottomLeft: "0",
              bottomRight: "0",
            },
          },
          shadow: null,
        },
        hover: {
          font: {
            style: null,
            fontSize: null,
            fontFamily: null,
            lineSpacing: null,
            letterSpacing: null,
            color: {
              type: "solid",
              r: 0,
              g: 0,
              b: 0,
              a: 1,
            },
          },
          background: {
            type: "solid",
            r: 0,
            g: 0,
            b: 0,
            a: 0,
          },
          border: null,
          shadow: null,
        },
        alignment: null,
        animation: null,
      },
      mobile: {
        visible: true,
        layout: {
          transform: {
            translate: "76.895px, 395px",
            rotate: "0deg",
            scale: "1,1",
          },
          width: "181.21px",
          height: "20px",
        },
        regular: {
          font: {
            style: null,
            fontSize: "13",
            fontWeight: "550",
            fontFamily: null,
            lineSpacing: null,
            letterSpacing: null,
            color: null,
          },
          background: null,
          border: null,
          shadow: null,
        },
        hover: {
          font: {
            style: null,
            fontSize: null,
            fontFamily: null,
            lineSpacing: null,
            letterSpacing: null,
            color: null,
          },
          background: null,
          border: null,
          shadow: null,
        },
        alignment: null,
        animation: null,
      },
    },
    content: "Resend code to your email",
  },
];

export const forms = [
  {
    id: "basic_Form",
    name: "Basic Form",
    render: () => {
      return (
        <img
          className={cx(styles.form, styles.basic)}
          src="/images/palette/form/basic.png"
        />
      );
    },
    data: {
      type: FORM,
      name: "Form",
      properties: {
        desktop: {
          visible: true,
          layout: {
            transform: {
              translate: `0px, 0px`,
              rotate: "0deg",
            },
            width: "600px",
            height: "415px",
          },
          border: null,
          background: {
            type: "solid",
            r: 245,
            g: 245,
            b: 245,
            a: 1,
          },
          formEmailTemplate: null,
        },
        mobile: {
          visible: true,
          layout: {
            transform: {
              translate: `0px, 0px`,
              rotate: "0deg",
            },
            width: "335px",
            height: "463px",
          },
          border: null,
          background: null,
          formEmailTemplate: null,
        },
      },
      content: null,
      widgets: [
        {
          type: FORM_STEP,
          name: "Form",
          properties: {
            desktop: {
              visible: true,
              layout: {
                transform: {
                  translate: "0px, 0px",
                  rotate: "0deg",
                },
                width: null,
                height: null,
              },
            },
            mobile: {
              visible: true,
              layout: {
                transform: {
                  translate: "0px, 0px",
                  rotate: "0deg",
                },
                width: null,
                height: null,
              },
            },
          },
          widgets: [
            {
              type: TEXT,
              name: "Form Title",
              properties: {
                desktop: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "30px,30px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "auto",
                    height: "auto",
                  },
                  fontSize: "16",
                  lineSpacing: "1.2",
                  letterSpacing: "0",
                  color: null,
                  alignment: "left",
                  animation: null,
                },
                mobile: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "20px,20px",
                      rotate: "0deg",
                    },
                    width: "233.875px",
                    height: "auto",
                  },
                  fontSize: "32",
                  lineSpacing: "1.2",
                  letterSpacing: "0",
                  color: null,
                  alignment: "left",
                  animation: null,
                },
              },
              content: "<h3>Get in touch</h3>",
            },
            {
              type: FORM_FIELD,
              name: "First Name",
              properties: {
                desktop: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "30px,96px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "255px",
                    height: "auto",
                  },
                  field: "firstname",
                  label: "First Name",
                  placeholder: "Enter first name",
                  workEmail: false,
                  mandatory: false,
                  styles: {
                    layout: {
                      alignment: "left",
                      labelPadding: "0",
                      inputPadding: "12",
                      fieldSpacing: "2",
                      regular: null,
                    },
                    regular: {
                      border: {
                        sides: null,
                        color: {
                          type: "solid",
                          r: 0,
                          g: 0,
                          b: 0,
                          a: 1,
                        },
                        width: "2",
                        radius: null,
                        style: "bottom",
                      },
                      label: {
                        background: null,
                        color: {
                          type: "solid",
                          r: 0,
                          g: 0,
                          b: 0,
                          a: 1,
                        },
                        placeholderColor: null,
                        font: {
                          style: null,
                          fontSize: "12",
                          fontFamily: "Montserrat,sans-serif",
                          lineSpacing: null,
                          letterSpacing: null,
                          color: null,
                        },
                      },
                      input: {
                        background: {
                          type: "solid",
                          r: 255,
                          g: 255,
                          b: 255,
                          a: 1,
                        },
                        color: {
                          type: "solid",
                          r: 0,
                          g: 0,
                          b: 0,
                          a: 1,
                        },
                        placeholderColor: {
                          type: "solid",
                          r: 213,
                          g: 213,
                          b: 213,
                          a: 1,
                        },
                        font: {
                          style: null,
                          fontSize: "14",
                          fontFamily: "Montserrat,sans-serif",
                          lineSpacing: null,
                          letterSpacing: null,
                          color: null,
                        },
                      },
                    },
                  },
                },
                mobile: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "19px,78.484375px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "295px",
                    height: "auto",
                  },
                  field: null,
                  label: null,
                  placeholder: null,
                  workEmail: false,
                  mandatory: false,
                  styles: {
                    layout: {
                      alignment: "left",
                      labelPadding: "0",
                      inputPadding: "12",
                      fieldSpacing: "2",
                      regular: null,
                    },
                  },
                },
              },
            },
            {
              type: FORM_FIELD,
              name: "Last Name",
              properties: {
                desktop: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "310px,96px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "255px",
                    height: "auto",
                  },
                  field: "lastname",
                  label: "Last Name",
                  placeholder: "Enter last name",
                  workEmail: false,
                  mandatory: false,
                  styles: {
                    layout: {
                      alignment: "left",
                      labelPadding: "0",
                      inputPadding: "12",
                      fieldSpacing: "2",
                      regular: null,
                    },
                    regular: {
                      border: {
                        sides: null,
                        color: {
                          type: "solid",
                          r: 0,
                          g: 0,
                          b: 0,
                          a: 1,
                        },
                        width: "2",
                        radius: null,
                        style: "bottom",
                      },
                      label: {
                        background: null,
                        color: {
                          type: "solid",
                          r: 0,
                          g: 0,
                          b: 0,
                          a: 1,
                        },
                        placeholderColor: null,
                        font: {
                          style: null,
                          fontSize: "12",
                          fontFamily: "Montserrat,sans-serif",
                          lineSpacing: null,
                          letterSpacing: null,
                          color: null,
                        },
                      },
                      input: {
                        background: {
                          type: "solid",
                          r: 255,
                          g: 255,
                          b: 255,
                          a: 1,
                        },
                        color: {
                          type: "solid",
                          r: 0,
                          g: 0,
                          b: 0,
                          a: 1,
                        },
                        placeholderColor: {
                          type: "solid",
                          r: 213,
                          g: 213,
                          b: 213,
                          a: 1,
                        },
                        font: {
                          style: null,
                          fontSize: "14",
                          fontFamily: "Montserrat,sans-serif",
                          lineSpacing: null,
                          letterSpacing: null,
                          color: null,
                        },
                      },
                    },
                  },
                },
                mobile: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "19px,159.50037499999996px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "295px",
                    height: "auto",
                  },
                  field: null,
                  label: null,
                  placeholder: null,
                  workEmail: false,
                  mandatory: false,
                  styles: {
                    layout: {
                      alignment: "left",
                      labelPadding: "0",
                      inputPadding: "12",
                      fieldSpacing: "2",
                      regular: null,
                    },
                  },
                },
              },
            },
            {
              type: FORM_FIELD,
              name: "Email",
              properties: {
                desktop: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "30px,179px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "540px",
                    height: "auto",
                  },
                  field: "email",
                  label: "Email",
                  placeholder: "Enter email address",
                  workEmail: true,
                  mandatory: true,
                  styles: {
                    layout: {
                      alignment: "left",
                      labelPadding: "0",
                      inputPadding: "12",
                      fieldSpacing: "2",
                      regular: null,
                    },
                    regular: {
                      border: {
                        sides: null,
                        color: {
                          type: "solid",
                          r: 0,
                          g: 0,
                          b: 0,
                          a: 1,
                        },
                        width: "2",
                        radius: null,
                        style: "bottom",
                      },
                      label: {
                        background: null,
                        color: {
                          type: "solid",
                          r: 0,
                          g: 0,
                          b: 0,
                          a: 1,
                        },
                        placeholderColor: null,
                        font: {
                          style: null,
                          fontSize: "12",
                          fontFamily: "Montserrat,sans-serif",
                          lineSpacing: null,
                          letterSpacing: null,
                          color: null,
                        },
                      },
                      input: {
                        background: {
                          type: "solid",
                          r: 255,
                          g: 255,
                          b: 255,
                          a: 1,
                        },
                        color: {
                          type: "solid",
                          r: 0,
                          g: 0,
                          b: 0,
                          a: 1,
                        },
                        placeholderColor: {
                          type: "solid",
                          r: 213,
                          g: 213,
                          b: 213,
                          a: 1,
                        },
                        font: {
                          style: null,
                          fontSize: "14",
                          fontFamily: "Montserrat,sans-serif",
                          lineSpacing: null,
                          letterSpacing: null,
                          color: null,
                        },
                      },
                    },
                  },
                },
                mobile: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "19px,240.51673242187496px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "295px",
                    height: "auto",
                  },
                  field: null,
                  label: null,
                  placeholder: null,
                  workEmail: false,
                  mandatory: false,
                  styles: {
                    layout: {
                      alignment: "left",
                      labelPadding: "0",
                      inputPadding: "12",
                      fieldSpacing: "2",
                      regular: null,
                    },
                  },
                },
              },
            },
            {
              type: FORM_FIELD,
              name: "Company",
              properties: {
                desktop: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "30px,262px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "540px",
                    height: "auto",
                  },
                  field: "company",
                  label: "Company",
                  placeholder: "Enter company",
                  workEmail: false,
                  mandatory: false,
                  styles: {
                    layout: {
                      alignment: "left",
                      labelPadding: "0",
                      inputPadding: "12",
                      fieldSpacing: "2",
                      regular: null,
                    },
                    regular: {
                      border: {
                        sides: null,
                        color: {
                          type: "solid",
                          r: 0,
                          g: 0,
                          b: 0,
                          a: 1,
                        },
                        width: "2",
                        radius: null,
                        style: "bottom",
                      },
                      label: {
                        background: null,
                        color: {
                          type: "solid",
                          r: 0,
                          g: 0,
                          b: 0,
                          a: 1,
                        },
                        placeholderColor: null,
                        font: {
                          style: null,
                          fontSize: "12",
                          fontFamily: "Montserrat,sans-serif",
                          lineSpacing: null,
                          letterSpacing: null,
                          color: null,
                        },
                      },
                      input: {
                        background: {
                          type: "solid",
                          r: 255,
                          g: 255,
                          b: 255,
                          a: 1,
                        },
                        color: {
                          type: "solid",
                          r: 0,
                          g: 0,
                          b: 0,
                          a: 1,
                        },
                        placeholderColor: {
                          type: "solid",
                          r: 213,
                          g: 213,
                          b: 213,
                          a: 1,
                        },
                        font: {
                          style: null,
                          fontSize: "14",
                          fontFamily: "Montserrat,sans-serif",
                          lineSpacing: null,
                          letterSpacing: null,
                          color: null,
                        },
                      },
                    },
                  },
                },
                mobile: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "18.5px,321.5328134765624px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "295px",
                    height: "auto",
                  },
                  field: null,
                  label: null,
                  placeholder: null,
                  workEmail: false,
                  mandatory: false,
                  styles: {
                    layout: {
                      alignment: "left",
                      labelPadding: "0",
                      inputPadding: "12",
                      fieldSpacing: "2",
                      regular: null,
                    },
                  },
                },
              },
            },
            {
              type: FORM_SUBMIT,
              name: "Submit Button",
              properties: {
                desktop: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "30px,345px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "200px",
                    height: "40px",
                  },
                  regular: {
                    font: {
                      style: {
                        bold: false,
                        italic: false,
                        underline: false,
                      },
                      fontSize: "14",
                      fontFamily: null,
                      lineSpacing: null,
                      letterSpacing: null,
                      color: {
                        type: "solid",
                        r: 0,
                        g: 0,
                        b: 0,
                        a: 1,
                      },
                    },
                    background: {
                      type: "solid",
                      r: 255,
                      g: 198,
                      b: 0,
                      a: 1,
                    },
                    border: {
                      sides: null,
                      color: null,
                      width: "0",
                      radius: {
                        lock: true,
                        topLeft: "20",
                        topRight: "20",
                        bottomLeft: "20",
                        bottomRight: "20",
                      },
                    },
                    shadow: null,
                  },
                  hover: {
                    font: {
                      style: null,
                      fontSize: null,
                      fontFamily: null,
                      lineSpacing: null,
                      letterSpacing: null,
                      color: {
                        type: "solid",
                        r: 0,
                        g: 0,
                        b: 0,
                        a: 1,
                      },
                    },
                    background: {
                      type: "solid",
                      r: 255,
                      g: 198,
                      b: 0,
                      a: 1,
                    },
                    border: null,
                    shadow: null,
                  },
                  alignment: null,
                  animation: null,
                },
                mobile: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "19px,402.4998134765624px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "200px",
                    height: "40px",
                  },
                  regular: {
                    font: {
                      style: null,
                      fontSize: "14",
                      fontFamily: null,
                      lineSpacing: null,
                      letterSpacing: null,
                      color: null,
                    },
                    background: null,
                    border: null,
                    shadow: null,
                  },
                  hover: {
                    font: {
                      style: null,
                      fontSize: null,
                      fontFamily: null,
                      lineSpacing: null,
                      letterSpacing: null,
                      color: null,
                    },
                    background: null,
                    border: null,
                    shadow: null,
                  },
                  alignment: null,
                  animation: null,
                },
              },
              content: "Submit",
            },
          ],
        },
        {
          type: FORM_STEP,
          name: "Success",
          properties: {
            desktop: {
              visible: true,
              layout: {
                transform: {
                  translate: "0px, 0px",
                  rotate: "0deg",
                },
                width: null,
                height: null,
              },
            },
            mobile: {
              visible: true,
              layout: {
                transform: {
                  translate: "0px, 0px",
                  rotate: "0deg",
                },
                width: null,
                height: null,
              },
            },
          },
          widgets: [
            {
              type: TEXT,
              name: "Form Title",
              properties: {
                desktop: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "30px,268px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "353.461px",
                    height: "auto",
                  },
                  fontSize: "16",
                  lineSpacing: "1.2",
                  letterSpacing: "0",
                  color: null,
                  alignment: "left",
                  animation: null,
                },
                mobile: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "20px,336.00048828125px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "261px",
                    height: "auto",
                  },
                  fontSize: "32",
                  lineSpacing: "1.2",
                  letterSpacing: "0",
                  color: null,
                  alignment: "left",
                  animation: null,
                },
              },
              content:
                "<h3><strong>Thanks </strong></h3>\n<h3><strong>for submitting!</strong></h3>",
            },
            {
              type: TEXT,
              name: "Form Title",
              properties: {
                desktop: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "30px, 360px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "auto",
                    height: "auto",
                  },
                  fontSize: "16",
                  lineSpacing: "1.2",
                  letterSpacing: "0",
                  color: null,
                  alignment: "left",
                  animation: null,
                },
                mobile: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "20px, 415px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "238.4921875px",
                    height: "auto",
                  },
                  fontSize: "16",
                  lineSpacing: "1.2",
                  letterSpacing: "0",
                  color: null,
                  alignment: "left",
                  animation: null,
                },
              },
              content: "<p>We’ll get back to you shortly :)</p>",
            },
            {
              type: "cleverstory.v2.widgets.image",
              name: "Image",
              capabilities: null,
              order: 1,
              fonts: null,
              actions: null,
              properties: {
                desktop: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "198.0000000000001px,48.99999999999969px",
                      rotate: "0deg",
                      scale: "1,1",
                    },
                    width: "317px",
                    height: "274.961px",
                  },
                  crop: null,
                  alt: null,
                  animation: null,
                  border: null,
                  position: null,
                  shadow: null,
                },
                mobile: {
                  visible: true,
                  layout: {
                    transform: {
                      translate: "20px,20px",
                      rotate: "0deg",
                    },
                    width: "295px",
                    height: "256.0584635416667px",
                  },
                  crop: null,
                  alt: null,
                  animation: null,
                  border: null,
                  position: null,
                  shadow: null,
                },
              },
              content: {
                id: imageId,
                contentType: "image/png",
                type: "image",
                width: 500.0,
                height: 434.0,
                url: `public/cleverstory/v2/media/images/${imageId}/thankyou.png`,
              },
            },
          ],
        },
        {
          type: FORM_STEP,
          name: "OTP",
          properties: {
            desktop: {
              visible: true,
              layout: {
                transform: {
                  translate: "0px, 0px",
                  rotate: "0deg",
                },
                width: null,
                height: null,
              },
            },
            mobile: {
              visible: true,
              layout: {
                transform: {
                  translate: "0px, 0px",
                  rotate: "0deg",
                },
                width: null,
                height: null,
              },
            },
          },
          widgets: defaultOtpWidgets,
        },
      ],
    },
  },
];
